import {
  createNgReactBridgeFactory,
  createNgReactBridgeConstant
} from '../../react-bridge'
import { ServiceUtils, legacyLoggerConstant } from './legacy-service-utils'
createNgReactBridgeConstant('LOGGER', legacyLoggerConstant)
createNgReactBridgeFactory('ServiceUtils', ServiceUtils)
